import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { PageHead } from "../ui/PageHead";
import { EmptyState } from "../ui/EmptyState";
import { appPath } from "../app/routes";

/**
 * Endereço que não corresponde a nenhuma superfície.
 *
 * Um erro de rota não pode virar tela preta ou vazia (§18): a página diz o que
 * houve e oferece a saída, em vez de deixar a pessoa sem caminho de volta.
 */
export function NaoEncontradaPage() {
  return (
    <>
      <PageHead title="Página não encontrada" sub="O endereço não existe na interface nova" />
      <EmptyState
        icon={<Compass size={22} aria-hidden="true" />}
        title="Este endereço não corresponde a nenhuma tela"
        description="Ele pode ter mudado durante o porte, ou o link estar incompleto."
        action={
          <Link className="cx-btn" data-variant="primary" to={appPath()}>
            Ir para o Início
          </Link>
        }
      />
    </>
  );
}
